
// export default () => ({
    
// })

export default () => ({
    contracts: null,
    typeContracts: null,
    periods: null,
})
